
const colorSwatchValues = {
"black": "black",
"black/black": "black",
"black/beige": "black",
"black/cream": "black",
"black/gold": "black",
"black/multi": "black",
"black/neutral": "black",
"black/nude": "black",
"black/silver": "black",
"black/tan": "black",
"black/white": "black",
"aqua": "lightblue",
"baby": "lightblue",
"sky": "lightblue",
"blue": "midblue",
"bluebell": "midblue",
"china": "darkblue",
"cobalt": "colour-cobalt",
"dark": "darkblue",
"denim": "midblue",
"dusty": "lightblue",
"lapis": "midblue",
"light": "lightblue",
"medium": "midblue",
"scarlet": "brightorange",
"navy": "darkblue",
"pale": "lightblue",
"pastel": "lightblue",
"petrol": "darkblue",
"powder": "midblue",
"royal": "midblue",
"sea": "midblue",
"skyblue": "lightblue",
"tender": "midblue",
"turq": "midblue",
"turquoise": "midblue",
"wedgewood": "midblue",
"blue/beige": "midblue",
"blue/white": "midblue",
"navy/cream": "darkblue",
"navy/white": "darkblue",
"niagra": "midblue",
"stripe": "midblue",
"brown": "midbrown",
"chestnut": "midbrown",
"chocolate": "midbrown",
"leopard": "midbrown",
"light": "lightbrown",
"mocha": "midbrown",
"lime": "midgreen",
"sand": "lightbrown",
"tan": "midbrown",
"tobacco": "midbrown",
"black/silver": "silver",
"black/suede": "black",
"black/blue": "black",
"taupe/suede": "taupe",
"truffle": "midbrown",
"warm": "midbrown",
"brown/gold": "midbrown",
"burgundy": "burgundy",
"oxblood": "burgundy",
"wine": "burgundy",
"camel": "camel",
"coral": "coral",
"dusty": "coral",
"beige": "colour-beige",
"champagne": "cream",
"cream": "cream",
"cream/cream": "cream",
"ivory": "cream",
"natural": "cream",
"oatmeal": "cream",
"shell": "colour-shell",
"stone": "lightbrown",
"cream/black": "cream",
"cream/nude": "cream",
"stone/white": "lightbrown",
"avocado": "colour-avocado",
"dark": "darkgreen",
"green": "midgreen",
"kale": "midgreen",
"khaki": "khaki",
"indigo": "indigo",
"lime": "lime",
"mint": "lightgreen",
"olive": "colour-olive",
"sage": "colour-sage",
"teal": "midgreen",
"cinnamon": "cinnamon",
"mint/white": "midgreen",
"charcoal": "midgrey",
"dove": "midgrey",
"grey": "midgrey",
"greymarl": "midgrey",
"smoke": "midgrey",
"cloud": "midgrey",
"grey/black": "midgrey",
"grey/dark": "darkgrey",
"grey/light": "lightgrey",
"bronze": "bronze",
"copper": "bronze",
"gold": "gold",
"metallic": "silver",
"silver": "silver",
"bronze/foil": "bronze",
"gold/coral/turquoise": "gold",
"gold/cream": "gold",
"gold/multi": "gold",
"gold/pink/white": "gold",
"gold/rhodium": "gold",
"gold/silver/rose": "gold",
"gold/turquoise": "gold",
"gold/white": "gold",
"silver/black": "silver",
"silver/gold/rose": "silver",
"silver/white": "silver",
"monochrome": "mono",
"multi": "multi",
"multi/creammesh": "multi",
"multi/gold": "multi",
"nude/multi": "nude",
"nude/white": "nude",
"nude": "nude",
"taupe": "nude",
"apricot": "colour-apricot",
"bright": "midorange",
"burnt": "midorange",
"deep": "midorange",
"orange": "midorange",
"peach": "midorange",
"rust": "midorange",
"terracotta": "midorange",
"rose/cream": "midpink",
"antique": "midpink",
"baby": "lightpink",
"blush": "midpink",
"bright": "brightpink",
"bubblegum": "midpink",
"cerise": "midpink",
"dark": "midpink",
"dusky pink": "lightpink",
"dusty": "lightpink",
"elderberry": "midpink",
"electric": "midpink",
"fluorescent": "brightpink",
"freesa": "midpink",
"fuchsia": "brightpink",
"fusia": "brightpink",
"hot": "brightpink",
"lightpink": "lightpink",
"magenta": "brightpink",
"mink": "midpink",
"neon": "brightpink",
"pale": "lightpink",
"pastel": "lightpink",
"pink": "midpink",
"raspberry": "colour-raspberry",
"rose": "midpink",
"salmon": "midpink",
"aubergine": "darkpurple",
"lilac": "lightpurple",
"mauve": "midpurple",
"plum": "colour-plum",
"purple": "midpurple",
"berry": "darkred",
"flame": "midred",
"poppy": "midred",
"red": "colour-red",
"scarelet": "midred",
"white": "white",
"white/white": "white",
"white/black": "white",
"white/camel": "white",
"white/gold": "white",
"white/grey": "white",
"white/navy": "white",
"white/nude": "white",
"white/pink": "white",
"ochre": "midyellow",
"ocre": "midyellow",
"bright": "brightyellow",
"daffodil": "brightyellow",
"honeydew": "brightyellow",
"lemon": "colour-lemon",
"melon": "midyellow",
"mustard": "colour-mustard",
"yellow": "midyellow",
"freesia": "freesia",
"silver,": "silver",
"soft": "lightpurple",
"china-blue": "china-blue",
"cherry": "lightred",
"khaki": "darkgreen"
  };


function diff_string(t) {
    var e = Math.floor(t / 864e5);
    t -= 864e5 * e;
    var n = Math.floor(t / 36e5);
    t -= 36e5 * n;
    var i = Math.floor(t / 6e4);
    t -= 6e4 * i, seconds = Math.floor(t / 1e3);
    var o = "";
    return e > 0 && (o += e + " Days, "), n < 10 && (n = "0" + n), i < 10 && (i = "0" + i), seconds < 10 && (seconds = "0" + seconds), o += n + "h " + i + "m " + seconds + "s"
}

function bannersStartTimer() {
    banner_countdown_timer = setInterval(function() {
        bannersUpdateTimers()
    }, 1e3), bannersUpdateTimers();
}

function bannersUpdateTimers3() {
    alert('test');
}

function bannersUpdateTimers() {
    $(".countdown-timer").each(function(t) {
        var e = $(this).data("timer_expire");
        e < Math.floor(Date.now() / 1e3) ? $(this).html(diff_string(Date.now() - Date.now())) : $(this).html(diff_string(1e3 * e - Date.now()))
    })
}


$(document).ready(function() {
    bannersStartTimer();

    $( ".qty-change-btn a" ).on( "click", function() {

        if ($(this).parent().parent().find(".qty-changer").css("visibility") == "visible") {
            console.log('1');
            $(this).parent().parent().find(".qty-changer").css('visibility', 'hidden');
        } else {
            console.log('2');
            $(this).parent().parent().find(".qty-changer").css('visibility', 'visible');
        }

        return false;
    });


    $( ".collections-view-items span" ).on( "click", function() {
        var number_of_items = $(this).attr("data-id");

        $( ".collections-view-items span" ).removeClass("view-item-active");
        $(this).addClass("view-item-active");

        change_view_items(number_of_items);
    });
});


function change_view_items(number) {
    switch(number) {
        case '2':
            assign_view_items("two-in-row");
            break;
        case '4':
            assign_view_items("four-in-row");
            break;
        case '6':
            assign_view_items("six-in-row");
            break;
    }
}

function assign_view_items(className) {
    $(".products-grid").removeClass("one-in-row two-in-row three-in-row four-in-row five-in-row six-in-row");

    $(".products-grid").addClass(className);
}

function collectionHideFilters() {
    if ($('#collection-page-content').hasClass('col-md-10')) {
        $('.filter-col').hide();
        $('#collection-page-content').removeClass('col-md-10');
    }
    else {
        $('.filter-col').show();
        $('#collection-page-content').addClass('col-md-10');
    }
}

function loadVerticalCarousel(init) {
    init = init || true;
    var getMainImageHeight = $(".main-image").height();

    $(".vertical-carousel-content").height(getMainImageHeight);

    var verticalImgHeight = getMainImageHeight / 4;

    $(".vertical-carousel-content #vertical-carousel img").each(function() {
        $(this).height(verticalImgHeight);
    });

    if (init) {
        $("#vertical-carousel").slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
            vertical: true,
            adaptiveHeight: true
        });
    }

    var verticalNextArrow = getMainImageHeight + 35;

    $("#vertical-carousel .slick-next").css("top", ""+verticalNextArrow+"px");
}

function productPageSocial() {
    $(".product-page-icons").css("margin-top", "0px");

    var imageHeight = $(".page-design-lotd .main-image").height();
    var contentHeight = $(".product-info-block").height();

    var result = imageHeight - contentHeight;



    if (result > 0) {
        $(".product-page-icons").css("margin-top", ""+result+"px");
    } else {
        $(".product-page-icons").css("margin-top", "5px");
    }
}

$(document).ready(function() {
    $( ".product-desc-show-more" ).on( "click", function() {

        if ($(".product-description-more").hasClass("active")) {
            $(".product-description").css({
                "height": "130px"
            });

            $(".product-desc-show-more").text("SHOW MORE");
            $(".product-description-more").removeClass("active");
        } else {
            $(".product-description").css({
                "height": "auto"
            });

            $(".product-desc-show-more").text("HIDE");
            $(".product-description-more").addClass("active");
        }

        productPageSocial();

        return false;
    });

});

var countBanners = 1;
function bannerChanger() {
    var checkWidth =  $(document).width();

        if (countBanners == "1") {
            $(".section_below_menu#for-mobile .sbm_left_column").hide();
            $(".section_below_menu#for-mobile .sbm_middle_column").show();
            $(".section_below_menu#for-mobile .sbm_right_column").hide();

            countBanners = 2;
        } else if (countBanners == "2") {
            $(".section_below_menu#for-mobile .sbm_left_column").hide();
            $(".section_below_menu#for-mobile .sbm_middle_column").hide();
            $(".section_below_menu#for-mobile .sbm_right_column").show();

            countBanners = 3;
        } else if (countBanners == "3") {
            $(".section_below_menu#for-mobile .sbm_left_column").show();
            $(".section_below_menu#for-mobile .sbm_middle_column").hide();
            $(".section_below_menu#for-mobile .sbm_right_column").hide();

            countBanners = 1;
        }

    setTimeout(function(){bannerChanger()}, 6 * 1000);
}


setTimeout(function(){bannerChanger()}, 6 * 1000);

function toggleFiltersMobile(close) {
    close  = close|| false;
    $(".filter-mobile-show").toggleClass("show-content-mobile");
    $(".mobile-filter-btn").addClass("active");
    $(".mobile-sort-btn").removeClass("active");
    if (close == true) $(".mobile-filter-btn").removeClass("active");
    $(".sort-mobile-show").removeClass("show-content-mobile");
}

function sortByMobile(close) {
     close  = close|| false;
    $(".filter-mobile-show").removeClass("show-content-mobile");
    $(".mobile-filter-btn").removeClass("active");
    $(".mobile-sort-btn").addClass("active");

    if (close == true) $(".mobile-sort-btn").removeClass("active");

    $(".sort-mobile-show").toggleClass("show-content-mobile");
}

$(function() {
    $( ".dropdown-mobile-account-content .mobile-header-user" ).on( "click", function() {

        return false;
    });

    // console.log('1');
    //
    // if ($("#cffLoadingLoadingCartModalBackground").length) {
    //     console.log('jest');
    // } else {
    //     console.log($("#cffLoadingLoadingCartModalBackground").text());
    // }
});


function countColors(product, id) {
    var splitCode = product.split('-');
    var jlCode = splitCode[splitCode.length-1];
    var splitCode3 = jlCode.substring(0, 2)

    var code = splitCode3.toLowerCase();

    if (code == "jl") {
        jQuery.getJSON('/search?view=json&type=product&q='+jlCode+'', function (result) {
            var colorResults = result.results;
            var count = 0;

            for (var key in colorResults) {

                if (!colorResults.hasOwnProperty(key)) continue;

                count = count + 1;
            }

            $("#product"+id+" .color-count #color-count").html(""+count+"");
        });
    } else {
        $("#product"+id+" .color-count #color-count").html("1");
    }
}


function countColorsImages(product, id) {

    var splitCode = product.split('-');
    var jlCode = splitCode[splitCode.length-1];
    var splitCode3 = jlCode.substring(0, 2)

    var code = splitCode3.toLowerCase();


    if (code == "jl") {

        jQuery.getJSON('/search?view=json&type=product&q='+jlCode+'', function (result) {
            var colorResults = result.results;

            var countResults =  Object.keys(colorResults).length;

            $("#product"+id+" .color-count").html('');

            if (countResults != 1) {
                for (var key in colorResults) {

                    if (!colorResults.hasOwnProperty(key)) continue;

                    var itemThumbnail = colorResults[key].thumbnail;
                    var itemUrl = colorResults[key].url;
                    var itemTitle = colorResults[key].title;

                    var splitTitle = itemTitle.split(" ", 2);
                    var firstWord = splitTitle[0].toLowerCase();

                    var colorLink = filesUrl.replace("img.png", "" + colorSwatchValues[firstWord] + ".png");


                    if (itemTitle == "{{ product.title }}") var active = ' active'; else var active = '';


                    $("#product" + id + " .color-count").append('<div class="item"><a href="' + itemUrl + '" title="' + firstWord + '"><img src="' + colorLink + '" /></a></div>');
                }
            }

        });
    }
}

function count_percent(was, now) {
    was = was / 100;
    now = now / 100;

    var count = ((was - now) / was) * 100;

    var result = Math.round(count);

    $("#save_percent").text(result);
}

function collection_description_mobile() {
    if (!$(".collection-description").hasClass("active")) {

        $(".collection-description").addClass("active")

        $(".lotd-description-arrow span").removeClass("arrow-down");
        $(".lotd-description-arrow span").addClass("arrow-up");

    } else {

        $(".collection-description").removeClass("active")

        $(".lotd-description-arrow span").removeClass("arrow-up");
        $(".lotd-description-arrow span").addClass("arrow-down");

    }
}

$(function(){
    $(".faq-left-column a").on('click', function() {
        $(".faq-tab").hide();

        var faqID = $(this).data('faq');

        $("#"+faqID).show();

        $(".faq-left-column .active").removeClass("active");
        $(this).addClass("active");
        $("span", this).addClass("active");

        return false;
    });

});

